const KEY = "threec_client_id";
const OVERRIDE_KEY = "3cai_active_user_id";

/** Called by AuthContext on login/logout so anonymous credits & authenticated
 * credits stay cleanly separate. When logged in, X-Client-Id == user.id so
 * the backend debits from the paid wallet the pack was credited to. */
export function setActiveUserId(userId) {
  try {
    if (userId) localStorage.setItem(OVERRIDE_KEY, userId);
    else localStorage.removeItem(OVERRIDE_KEY);
  } catch {
    // no-op
  }
}

export function getClientId() {
  try {
    const override = localStorage.getItem(OVERRIDE_KEY);
    if (override) return override;
  } catch {
    // fall through
  }
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = "c_" + (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
    localStorage.setItem(KEY, id);
  }
  return id;
}
